import { createBrowserRouter } from "react-router-dom";
import HomePage from "./pages/home";
import { CheckoutPage } from "./pages/checkout";
const router = createBrowserRouter([
  { path: "/", element: <HomePage /> },
  { path: "/checkout", element: <CheckoutPage /> },
]);

export default router;
